import { FC, useCallback } from "react";
import styled from "@emotion/styled";
import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
} from "@/pages/settings/components/settings-integration-layout";
import {
  MDSButton,
  MDSButtonSlotName,
  MDSIcon,
  MDSIconColor,
  MDSIconKind,
  MDSText,
  MDSTextVariant,
} from "@/mds";
import { windowModule } from "@/modules/window";

const REFERRAL_PROGRAM_URL = "https://mem.getrewardful.com/signup?campaign=mem-affiliate-program";

export const SettingsReferralProgramPage: FC = () => {
  const handleJoinReferralProgram = useCallback(() => {
    void windowModule.openInNewTab({ url: new URL(REFERRAL_PROGRAM_URL) });
  }, []);

  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader breadcrumb="Account" title="Referral program" />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <StyledBlock>
            <MDSText variant={MDSTextVariant.TextS}>
              Love Mem? Share us with your network and get paid when they subscribe to Pro.
            </MDSText>
            <StyledList>
              <li>
                <MDSText variant={MDSTextVariant.ParagraphS}>
                  Earn $5/month for every month a referred customer is subscribed to Mem Pro—up to
                  $50 per customer
                </MDSText>
              </li>
              <li>
                <MDSText variant={MDSTextVariant.ParagraphS}>
                  You can create a custom promo code that gives your referrals 20% off their first 3
                  months
                </MDSText>
              </li>
              <li>
                <MDSText variant={MDSTextVariant.ParagraphS}>
                  You get credit if they sign up within 60 days of clicking your link
                </MDSText>
              </li>
              <li>
                <MDSText variant={MDSTextVariant.ParagraphS}>
                  Commissions are posted 60 days after your referral upgrades, and payouts start at
                  $25
                </MDSText>
              </li>
            </StyledList>
            <MDSButton onPress={handleJoinReferralProgram}>
              Join the referral program
              <MDSIcon
                slot={MDSButtonSlotName.RightIcon}
                kind={MDSIconKind.ArrowUpRight}
                color={MDSIconColor.Primary}
              />
            </MDSButton>
          </StyledBlock>
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
};

const StyledList = styled.ul(({ theme }) => ({
  margin: 0,
  paddingTop: theme.spacing[2],
  paddingLeft: theme.spacing[5],
  color: theme.colors.text.primary,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[2],
}));

const StyledBlock = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.spacing[5],
  width: "100%",
}));
